import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/LoginScreen';
import MainScreen from './components/MainScreen';
import LicenseScreen from './components/LicenseScreen';
import QuotaScreen from './components/QuotaScreen';
import SarScreen from './components/SarScreen';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const MainScreenWrapper: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MainScreen
      onNavigateToLicense={() => navigate('/license')}
      onNavigateToQuota={() => navigate('/quota')}
      onNavigateToSar={() => navigate('/sar')}
    />
  );
};

const LicenseScreenWrapper: React.FC = () => {
  const navigate = useNavigate();
  return <LicenseScreen onBack={() => navigate('/')} />;
};

const QuotaScreenWrapper: React.FC = () => {
  const navigate = useNavigate();
  return <QuotaScreen onBack={() => navigate('/')} />;
};

const SarScreenWrapper: React.FC = () => {
  const navigate = useNavigate();
  return <SarScreen onBack={() => navigate('/')} />;
};

const LoginScreenWrapper: React.FC = () => {
  const navigate = useNavigate();
  return <LoginScreen onLoginSuccess={() => navigate('/')} />;
};

const AppRouter: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <LoginScreenWrapper />
            )
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainScreenWrapper />
            </ProtectedRoute>
          }
        />
        <Route
          path="/license"
          element={
            <ProtectedRoute>
              <LicenseScreenWrapper />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quota"
          element={
            <ProtectedRoute>
              <QuotaScreenWrapper />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sar"
          element={
            <ProtectedRoute>
              <SarScreenWrapper />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRouter />
      </div>
    </AuthProvider>
  );
}

export default App;
